import type {
    DeviceScheduleListQuery,
    DeviceScheduleListResponse,
    ScheduleV2ListQuery,
    ScheduleV2ListResponse,
    ScheduleV2UncoveredListQuery,
} from 'chaika-frontend-types/frontend-cms';

import { axios } from '@lib/axios';

const BASE_URL = '/api/schedule/v2';

export class ScheduleV2Api {
    public static async getList(params: ScheduleV2ListQuery): Promise<ScheduleV2ListResponse> {
        const res = await axios.get<ScheduleV2ListResponse>(BASE_URL, { params });

        return res.data;
    }

    public static async getUncoveredList(params: ScheduleV2UncoveredListQuery): Promise<ScheduleV2ListResponse> {
        const res = await axios.get<ScheduleV2ListResponse>(`${BASE_URL}/uncovered`, { params });

        return res.data;
    }

    public static async getDeviceList(params: DeviceScheduleListQuery): Promise<DeviceScheduleListResponse> {
        const res = await axios.get<DeviceScheduleListResponse>(`${BASE_URL}/device`, { params });

        return res.data;
    }
}
